import React, { useMemo } from 'react';
import {
  FormGroup,
  Grid,
  useAssetParams,
  useAssetTranslation,
  useUserinfo,
} from '@mss/mss-component-library';
import { subtypeOptions } from './util';
import { Input } from 'formik-antd/lib/input';
import { Select } from 'formik-antd/lib/select';
import { ErrorMessage } from 'formik';
import { Trans } from 'react-i18next';
import { useAllMonitorsQuery } from '../../../asset/services/queries';
import { findScopedMonitors } from '../utils/findScopedMonitors';

type Props = { updateAssetType?: () => void };
export default function ProfileForm({ updateAssetType }: Props) {
  const { t } = useAssetTranslation();
  const { assetType = 'field' } = useAssetParams();
  const [hasPermission] = useUserinfo();
  const canEdit = hasPermission('change_automationmonitorprofile');
  const { data: allMonitors } = useAllMonitorsQuery();
  const hasMultipleAssetSubTypes = subtypeOptions[assetType].length > 1;
  const hasSharedMonitors = useMemo(
    () => findScopedMonitors(allMonitors ?? [], { assetType }).length,
    [allMonitors, assetType]
  );

  return (
    <>
      <Grid.Col width={updateAssetType ? 8 : 7}>
        <FormGroup
          required
          label={t('Name')}
          input={
            <Input name="name" disabled={!canEdit} max={200} maxLength={200} />
          }
          error={
            <ErrorMessage
              name="name"
              render={msg => (
                <Trans ns={['common', 'validation', 'asset']}>{msg}</Trans>
              )}
            />
          }
        />
      </Grid.Col>
      <Grid.Col width={updateAssetType ? 4 : 3}>
        <FormGroup
          label={t('Asset / Application sub type')}
          input={
            <Select
              className="w-full"
              allowClear
              disabled={assetType === 'field' || !updateAssetType || !canEdit}
              options={[
                ...(hasSharedMonitors && hasMultipleAssetSubTypes && assetType !== 'network'
                  ? [
                      {
                        label: t('None'),
                        value: '-',
                      },
                    ]
                  : []),
                ...(subtypeOptions[assetType] ?? []).map(subtype => ({
                  label: t(subtype),
                  value: subtype,
                })),
              ]}
              name="assetSubType"
              onChange={() => {
                updateAssetType?.();
              }}
            />
          }
        />
      </Grid.Col>
    </>
  );
}
